export var LottieSizeTokens;
(function (LottieSizeTokens) {
    LottieSizeTokens["XS"] = "XS";
    LottieSizeTokens["Size28"] = "Size28";
    LottieSizeTokens["Size20"] = "Size20";
    LottieSizeTokens["SM"] = "SM";
    LottieSizeTokens["MD"] = "MD";
    LottieSizeTokens["LG"] = "LG";
    LottieSizeTokens["XL"] = "XL";
    LottieSizeTokens["XXL"] = "XXL";
    LottieSizeTokens["XXXL"] = "XXXL";
    LottieSizeTokens["FULL"] = "FULL";
    LottieSizeTokens["Size_56"] = "Size_56";
    LottieSizeTokens["Size_80"] = "Size_80";
    LottieSizeTokens["Size_96"] = "Size_96";
    LottieSizeTokens["Size_140"] = "Size_140";
    LottieSizeTokens["Size_240"] = "Size_240";
    LottieSizeTokens["Size_312"] = "Size_312";
    LottieSizeTokens["Size_560"] = "Size_560";
})(LottieSizeTokens || (LottieSizeTokens = {}));
export var LottieTokens;
(function (LottieTokens) {
    LottieTokens["Welcome"] = "welcome";
    LottieTokens["Confetti"] = "confetti";
    LottieTokens["Loading"] = "loading";
    LottieTokens["UnlockNew"] = "unlockNew";
    LottieTokens["LoadingSplash"] = "LoadingSplash";
    LottieTokens["Gift"] = "Gift";
    LottieTokens["SandTimer"] = "SandTimer";
    LottieTokens["PartyPopper"] = "PartyPopper";
    LottieTokens["SSOLogin"] = "SSOLogin";
    LottieTokens["Success"] = "Success";
    LottieTokens["Enhance_Limit_Success"] = "Enhance_Limit_Success";
    LottieTokens["PaymentSuccess"] = "PaymentSuccess";
    LottieTokens["PhonePe_Success"] = "PhonePe_Success";
    LottieTokens["kyc_loading"] = "kyc_loading";
    LottieTokens["Fetch_loading"] = "Fetch_loading";
})(LottieTokens || (LottieTokens = {}));
